import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { Config } from '@forgerock/javascript-sdk';
import { cLog , environmentConfig } from '@lpl/core';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { createForgeRockTransactionIdMiddleware } from './app/modules/core/forgerock/forgerock-transaction-id';

if (environment.production) {
  enableProdMode();
}

Config.set({
  clientId: 'ForgeRockSDKClient',
  scope: 'openid profile email',
  redirectUri:  window.location.origin,
  serverConfig: {
    baseUrl: environmentConfig.getPropertyValue('frBaseUrl') ,
    timeout: 10000
  },
  realmPath:  environmentConfig.getPropertyValue('realmPath'), // On-premise AM: 'root', Cloud AM: 'alpha' or 'beta'. 
  middleware: [createForgeRockTransactionIdMiddleware()],
});

//console.log(Config.get());

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
